import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { DialogActions, Grid, Button, Box } from "@material-ui/core";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { TextField as TextF } from "formik-material-ui";
import useAxiosPrivate from "../../utils/hooks/useAxiosPrivate";
import styles from '../journal/overlay.module.css';
import ModalCloseButton from "../../components/UI/ModalCloseButton";
import Alert from "@material-ui/lab/Alert";
import moment from 'moment';
import { withStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import { useSelector } from "react-redux";

const CustomColorCheckbox = withStyles({
    root: {
        color: 'var(--primary-text-theme-color)',
        '&$checked': {
            color: 'var(--primary-text-theme-color)',
        },
    },
    checked: {},
})((props) => <Checkbox color='default' {...props} />);

export default function AddPrivateNote({ setOpen, open, players_id }) {
    const axiosInstance = useAxiosPrivate()
    const [now, setNow] = useState(() => moment());
    const [checked, setChecked] = React.useState(false);
    const [group_ID, setGroup_ID] = React.useState('');
    const coachName = useSelector((state) => state.auth.name);
    const [loading, setLoading] = useState(false);

    const handleChange = (event) => {
        setChecked(event.target.checked);
    };
    const [alert, setAlert] = useState({
        showAlert: false,
        severity: 'success',
        message: '',
    });
    const textFieldThemeProps = {
        InputLabelProps: {
            style: { color: "var(--primary-text-theme-color)" },
        },
        InputProps: {
            style: { color: "var(--primary-text-color)" },
        },
    };
    const handleClose = () => {
        setOpen(false);
        setChecked(false);
    };

    const [initialValues, setInitialValues] = useState({
        title: "",
        note: "",
        is_group_note: false,
        visibility: "private",
        display_date: "",
        reading_time: ""
    });

    let JournalValidationSchema = Yup.object().shape({
        title: Yup.string()
            .required("Title is required.")
            .max(60, "Maximum length for the title is 60."),
        note: Yup.string()
            .required("Note is required.")
            .max(255, "Maximum length for the note is 255."),
    });


    useEffect(() => {
        if (!open) return;

        loadData();
        setNow(moment());

        const interval = setInterval(() => setNow(moment()), 1000);
        return () => clearInterval(interval);
        // eslint-disable-next-line
    }, [open]);

    useEffect(() => {
        if (open) {
            setInitialValues({
                title: "",
                note: "",
                is_group_note: false,
                visibility: "private",
                display_date: "",
                reading_time: "",
            });
        }
    }, [open]);

    const loadData = async () => {
        try {
            const { data } = await axiosInstance.get("/team/players");
            const group_id = data?.data?.filter((item => item?.user_id === players_id))[0]?.team_id;
            setGroup_ID(group_id)
        } catch (error) {
            console.log(error)
        }
    };

    const submit = async (payload) => {
        setLoading(true);
        const { note, title } = payload;
        const data = {
            reading_time:
                moment().format("YYYY-MM-DD") +
                " " +
                moment().format("HH:mm:ss"),
            title,
            note,
            is_group_note: false,
            visibility: !checked ? "private" : "group",
            player_id: players_id,
            group_id: group_ID
        };

        try {
            await axiosInstance.post("/journal/add", data);
            setLoading(false);
            setAlert({
                showAlert: true,
                severity: 'Success',
                message: 'Note saved successfully!',
            });
            setTimeout(() => {
                setAlert({
                    showAlert: false,
                    severity: 'Success',
                    message: 'Note saved successfully!',
                });
                handleClose();
            }, 3000);
        } catch {
            setLoading(false);
            setAlert({
                showAlert: true,
                severity: 'error',
                message: 'Note sending failed!',
            });
            setTimeout(() => {
                setAlert({
                    showAlert: false,
                    severity: 'error',
                    message: 'Note sending failed!',
                });
            }, 5000);
        }
    };

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
        >
            <div
                style={{
                    backgroundColor: "var(--primary-popup-background-color)",
                    position: "relative",
                }}
            >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "right",
                    paddingRight: "2rem",
                    paddingTop: "2rem",
                }}
            >
                <ModalCloseButton
                    onClick={handleClose}
                    style={{ position: "static" }}
                />
            </Box>
            <Formik
                initialValues={initialValues}
                onSubmit={submit}
                validationSchema={JournalValidationSchema}
                enableReinitialize
            >
                {({ dirty, isValid, touched, errors, values }) => (
                    <Form
                        style={{
                            padding: '0 2.5rem 2.5rem 2.5rem',
                            color: "var(--primary-text-color)",
                        }}
                        readOnly
                    >
                        <DialogContent>
                            <Grid container spacing={2} alignItems="center" justifyContent="flex-start">
                                <Grid item md={3}>
                                    <div style={{ display: 'flex' }}>
                                        <CustomColorCheckbox
                                            style={{
                                                transform: 'scale(0.7)',
                                                padding: 0,
                                            }}
                                            checked={checked} onChange={handleChange}
                                        />
                                        <p className={styles.makePublic}>{"Public"}</p>
                                    </div>
                                </Grid>
                                <Grid md={12}>
                                    <Field
                                        name="title"
                                        component={TextF}
                                        label="Add Title"
                                        fullWidth
                                        className={`${styles.addTitleLabel} ${styles.themeTextField}`}
                                        {...textFieldThemeProps}
                                    />
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item md={5}>
                                        <p className={styles.dateText}>
                                            {now.format("dddd, MMMM DD, YYYY").toUpperCase()}
                                            <span style={{ marginLeft: "2rem" }}>
                                                {now.format("h:mm:ss A")}
                                            </span>
                                        </p>
                                    </Grid>
                                    <Grid item md={7}>
                                        <p className={styles.dateText}>Written by {coachName}</p>
                                    </Grid>
                                </Grid>
                                <Grid md={12}>
                                    <Field
                                        name="note"
                                        component={TextF}
                                        label="Take a note..."
                                        fullWidth
                                        multiline
                                        rows={10}
                                        className={`${styles.labelText} ${styles.themeTextField}`}
                                        {...textFieldThemeProps}
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                variant="contained"
                                disabled={!isValid || loading}
                                type="submit"
                                style={!isValid || loading ? {
                                    fontFamily: 'Poppins',
                                    fontWeight: 500,
                                    fontStyle: 'normal',
                                    width: '136px',
                                    height: '35px',
                                    backgroundColor: "var(--primary-button-disabled-background-color)",
                                    opacity: 0.5,
                                    borderRadius: '4px',
                                    padding: '10px 20px',
                                    gap: '10px',
                                    color: "var(--primary-button-disabled-text-color)", textTransform: 'capitalize'
                                } : alert.showAlert ? {
                                    fontFamily: 'Poppins',
                                    fontWeight: 500,
                                    fontStyle: 'normal',
                                    width: '136px',
                                    height: '35px',
                                    borderRadius: '4px',
                                    padding: '10px 20px',
                                    gap: '10px',
                                    backgroundColor: "var(--primary-popup-background-color)",
                                    color: "var(--primary-text-theme-color)",
                                    textTransform: "capitalize",
                                    border: "2px solid",
                                    borderColor: "var(--primary-text-theme-color)"
                                } : {
                                    fontFamily: 'Poppins',
                                    fontWeight: 500,
                                    fontStyle: 'normal',
                                    width: '136px',
                                    height: '35px',
                                    backgroundColor: "var(--primary-button-background-color)",
                                    borderRadius: '4px',
                                    padding: '10px 20px',
                                    gap: '10px',
                                    color: "var(--primary-button-text-color)", textTransform: 'capitalize'
                                }}
                            >{alert.showAlert ?
                                "Saved" : loading ? "Saving..." : "Save"}
                            </Button>
                        </DialogActions>
                        {alert.showAlert ? (
                            <div style={{ padding: '0.5rem 2rem' }}>
                                <Alert
                                    severity={alert.severity}
                                    onClose={() =>
                                        setAlert({
                                            ...alert,
                                            showAlert: false,
                                        })
                                    }
                                >
                                    {alert.message}
                                </Alert>
                            </div>
                        ) : <p style={{ height: "1.3rem" }}></p>}
                    </Form>
                )}
            </Formik>
            </div>
        </Dialog>
    );
}
